/* eslint-disable */

export default {
  init() {
		const blog_header = document.querySelector('.single-post__header');

    let ellipsis = [
      ...Array.from(document.querySelectorAll('.recent__post__title')),
      ...Array.from(document.querySelectorAll('.recent__post__excerpt'))
    ];

    ellipsis.forEach(e => {
      let ell = new Ellipsis(e);
      ell.calc();
      ell.set();
    });

	  ['load','resize'].map(e => window.addEventListener(e, () => {
			document.body.style.setProperty('--header-height', `-${blog_header.offsetHeight}px`)

	  }));


	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
}



// WEBPACK FOOTER //
// ./scripts/routes/singlePost.js